  <div
    class="header h-[55px] flex justify-start items-center pl-[50px] mb-[18px] bg-[#F1F3F5]"
  >
    <p class="!m-0">{{ projectName }} - {{labels.title}}</p>
    <p
      class="!mt-[10px] bg-white !ml-[15px] flex items-center justify-center tag"
    >
      Key Dates
    </p>
  </div>
  <!-- Issue of ITT  -->
  <div class="!pl-[50px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label> {{labels.issueOfRFPLabel}} </mat-label>
          <input
            matInput
            [matDatepicker]="issueitt"
            [formControl]="issueDateControl"
            [placeholder]="labels.issueOfRFPLabel"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="issueitt"
          ></mat-datepicker-toggle>
          <mat-datepicker #issueitt startView="year"></mat-datepicker>
        </mat-form-field>
        <mat-error
          *ngIf="issueDateControl.invalid && issueDateControl.touched"
          class="relative top-[-15px]"
        >
          Issue Date is required.
        </mat-error>
      </div>
    </div>

    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label> Clarification Deadline </mat-label>
          <input
            matInput
            [matDatepicker]="clarificationdeadline"
            [formControl]="clarificationDeadlineControl"
            placeholder="Clarification Deadline"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="clarificationdeadline"
          ></mat-datepicker-toggle>
          <mat-datepicker
            #clarificationdeadline
            startView="year"
          ></mat-datepicker>
        </mat-form-field>
        <mat-error
          *ngIf="clarificationDeadlineControl.invalid && clarificationDeadlineControl.touched"
          class="relative top-[-15px]"
        >
          Clarification Deadline Date is required.
        </mat-error>
      </div>
    </div>
  </div>

  <!-- Contract Award Notification -->
  <div class="!pl-[50px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label> Contract Award Notification </mat-label>
          <input
            matInput
            [matDatepicker]="contractaward"
            [formControl]="contractAwardNotificationControl"
            placeholder="Contract Award Notification"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="contractaward"
          ></mat-datepicker-toggle>
          <mat-datepicker #contractaward startView="year"></mat-datepicker>
        </mat-form-field>
        <mat-error
          *ngIf="contractAwardNotificationControl.invalid && contractAwardNotificationControl.touched"
          class="relative top-[-15px]"
        >
          Contract Award Notification Date is required.
        </mat-error>
      </div>
    </div>
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label> Contract Start Date</mat-label>
          <input
            matInput
            [matDatepicker]="startdate"
            [formControl]="contractStartDateControl"
            placeholder="Contract Start Date"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="startdate"
          ></mat-datepicker-toggle>
          <mat-datepicker #startdate startView="year"></mat-datepicker>
        </mat-form-field>
        <mat-error
          *ngIf="contractStartDateControl.invalid && contractStartDateControl.touched"
          class="relative top-[-15px]"
        >
          Contract Start Date is required.
        </mat-error>
      </div>
    </div>
  </div>
  <!-- Project Completion Date -->
  <div class="!pl-[50px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label> Project Completion Date </mat-label>
          <input
            matInput
            [matDatepicker]="completiondate"
            [formControl]="projectCompletionDateControl"
            placeholder="Project Completion Date"
          />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="completiondate"
          ></mat-datepicker-toggle>
          <mat-datepicker #completiondate startView="year"></mat-datepicker>
        </mat-form-field>
        <mat-error
          *ngIf="projectCompletionDateControl.invalid && projectCompletionDateControl.touched"
          class="relative top-[-15px]"
        >
          Project Completion Date is required.
        </mat-error>
      </div>
    </div>
  </div>
  <!-- Back and next Buttons -->
  <div
    class="relative bottom-0 right-0 !pr-[66px] !mb-[30px] !mt-[49px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
  >
    <div class="!w-[100%] flex justify-end items-center">
      <button (click)="moveToPreviousStep()" type="button" class="back-btn">
        Back
      </button>
      <button
        class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
        style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
        (click)="moveToNextStep()"
      >
        Next
      </button>
    </div>
  </div>
